import type {ReactElement} from 'react';
import React, {useEffect} from 'react';
import {Text, TextSize} from '@Components/text';
import {updateDesignerAttribution} from '@Components/poster-editor/components/poster-editing-side-panel/components/designer-attribution/designer-attribution.reducer';
import {ClickableDiv} from '@Components/clickable-div';
import {GA4EventName, GA4EventParamName} from '@Libraries/ga-events';
import styles from './designer-attribution.module.scss';
import {useAppDispatch, useAppSelector} from '@/hooks';

interface DesignerAttributionInfo {
  hashedId: string;
  name: string;
  profileLink: string;
  profilePicture: string;
}

export function DesignerAttribution(): ReactElement<any> | null {
  const designerAttribution = useAppSelector((state) => {
    return state.designerAttribution;
  });
  const idGalleryTemplate = useAppSelector((state) => {
    return state.posterEditor.posterObject?.idGalleryTemplate;
  });
  const dispatch = useAppDispatch();

  const updateDesigner = async (): Promise<void> => {
    try {
      const designerAttributionValues = (await window.PMW.readLocal('user/getTemplateCreatorProfileInfo', {
        id: idGalleryTemplate,
      })) as DesignerAttributionInfo;
      dispatch(
        updateDesignerAttribution({
          hashedId: designerAttributionValues.hashedId,
          name: designerAttributionValues.name,
          profilePicture: designerAttributionValues.profilePicture,
          profileLink: designerAttributionValues.profileLink,
        })
      );
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!idGalleryTemplate) {
      return;
    }
    void updateDesigner();
  }, [idGalleryTemplate]);

  return idGalleryTemplate ? (
    <li className={`${styles.container} spacing-m-t-6`}>
      <div className={`${styles.line} spacing-m-t-1`} />
      <div className="flex-center spacing-p-t-3">
        <ClickableDiv
          className={`flex-center ${styles.nameContainer}`}
          onClick={(): void => {
            window.PMW.gtm.trackGA4CustomEvent(GA4EventName.DESIGNER_PROFILE_CLICK, {[GA4EventParamName.HASHED_ID]: designerAttribution.hashedId});
            window.open(window.PMW.util.site_url(designerAttribution.profileLink), '_blank');
          }}
        >
          <img className={styles.img} src={designerAttribution.profilePicture} alt={designerAttribution.name} />
          <Text val={window.i18next.t('pmwjs_designed_by')} className="content-sub-text" size={TextSize.XXSMALL} />
          <Text val={designerAttribution.name} bold className={`${styles.designerName} content-body text-center`} size={TextSize.XXSMALL} />
        </ClickableDiv>
      </div>
    </li>
  ) : null;
}
